"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _log = require('shared/log');

// The client errors webserver/mfa_server.go returns (writeLoginMFAError), as
// sentences. Web login MFA, web sign-up phone verification, the org SMS step
// and the app's MFA screen share them.
 const mfaErrorMessages = {
  'Invalid MFA Code': "That code isn't right. Check the text and try again.",
  'MFA Challenge Expired': 'That code has expired. Send a new code and try again.',
  'Invalid MFA Challenge': 'That code has expired. Send a new code and try again.',
  'Too Many MFA Attempts': 'Too many wrong codes. Send a new code and try again.',
  'MFA Code Recently Sent': 'We just sent a code. Wait a few seconds before asking for another.',
  'Too Many MFA Sends': "We've sent too many codes. Wait a few minutes, then try again.",
  'Invalid Phone': "We can't text this number. Use a mobile number in a supported country.",
  'Invalid Token': 'This sign-up link no longer works. Start sign-up again.',
  'Token Expired': 'This sign-up link no longer works. Start sign-up again.',
  'Token Used': 'This sign-up link has already been used. Log in instead.',
}; exports.mfaErrorMessages = mfaErrorMessages

 const GENERIC_MFA_ERROR = 'Something went wrong. Please try again.'; exports.GENERIC_MFA_ERROR = GENERIC_MFA_ERROR





// The sentence for a failed MFA call. An unknown error falls back to a
// generic sentence and is still logged.
 const mfaErrorMessage = (e) => {
  const code = _optionalChain([(e ), 'optionalAccess', _ => _.response, 'optionalAccess', _2 => _2.Error])
  if (code && exports.mfaErrorMessages[code]) return exports.mfaErrorMessages[code]
  _log.log.error(e instanceof Error ? e : new Error(`Unmapped MFA error: ${_nullishCoalesce(code, () => ( String(e)))}`))
  return exports.GENERIC_MFA_ERROR
}; exports.mfaErrorMessage = mfaErrorMessage
